import { makeStyles } from '@material-ui/core/styles';
import { rem } from 'src/common/helpers/dimension-helper';

export const styles = makeStyles(theme => ({
  navigationLabel: {
    fontWeight: 500,
    lineHeight: 1,
    letterSpacing: 0.7,
    color: theme.palette.info.dark,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    padding: '0 1.17vw',
    fontSize: rem(1.5),
    '@media (max-width: 1600px)': {
      fontSize: rem(1.2),
    },
    '@media (max-width: 1366px)': {
      fontSize: rem(1.2),
    },
    '@media (width: 1366px) and (height: 768px)': {
      fontSize: rem(1.2),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.3),
    },
    '@media (max-width: 1024px)': {
      fontSize: rem(0.8),
    },
    '@media  (width: 1280px) and (height: 720px)': {
      fontSize: rem(1),
    },
    '@media  (width: 1024px) and (height: 768px)': {
      fontSize: rem(0.9),
    },
  },
  navigationHeight: {
    minHeight: '4.9vh',
  },
  navigationButton: {
    '& > button': {
      border: 0,
      background: 'none',
      minWidth: 0,
      padding: '1vw',
      '&:hover': {
        background: 'none',
      },
      '&.Mui-disabled': {
        background: 'none',
      },
    },
  },
  arrowIcon: {
    height: '2vh',
    width: '2vh',
  },
}));
